// Leitura do skin persistido pelo login no sessionStorage. Segue o mesmo estilo
// defensivo de auth-storage.ts: leitura no momento do uso, sem cache, e nunca
// lança — quem inicializa a moldura não deve quebrar por causa de um storage
// ausente ou inacessível (modo restrito do browser).
export interface ShellSkin {
  cor: string | null;
  logoHeader: string | null;
  logoHeaderReduzido: string | null;
  favicon: string | null;
}

/** Lê cor/logoHeader/logoHeaderReduzido/favicon do sessionStorage; ausente/ilegível vira null. */
export function readSkinFromStorage(): ShellSkin {
  return {
    cor: readKey('cor'),
    logoHeader: readKey('logoHeader'),
    logoHeaderReduzido: readKey('logoHeaderReduzido'),
    favicon: readKey('favicon'),
  };
}

function readKey(key: string): string | null {
  try {
    const value = sessionStorage.getItem(key);
    // "undefined" como string é o sentinela de ausência gravado pelo login legado
    // (setItem com valor undefined vira essa string); sem este filtro, o favicon
    // resolve para uma data URI inválida ("data:image/x-icon;base64,undefined")
    // e o ícone da aba desaparece após o login.
    return value?.length && value !== 'undefined' ? value : null;
  } catch {
    return null;
  }
}
